import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';
import { FormViewDecorator } from 'site-modules/shared/components/lead-form/unified-lead-form/views/form-view-decorator';

export const ModularFormViewAsync = FormViewDecorator(
  lazyLoad({
    loader: () => import(/* webpackChunkName: "modular-form-view" */ './modular-form-view'),
    componentName: 'ModularFormView',
  })
);
